import { render, staticRenderFns } from "./promoteSale-temp.vue?vue&type=template&id=f320ec4c&scoped=true&"
var script = {}
import style0 from "./promoteSale-temp.vue?vue&type=style&index=0&id=f320ec4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f320ec4c",
  null
  
)

export default component.exports